import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/merchants`;
const supplierResource = `/api/v1/suppliers`;
const resourceMerchantMonitorFields = '/api/v1/merchantmonitorfields';
const tempMerchantResource = 'api/v1/suppliers/by-visitors';
export default {
  getMerchantCompanies(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },

  editMerchantCompany(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/by-company`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantInformationById(
    merchantId,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.get(`${resource}/${merchantId}`, {
      baseURL,
      headers,
      params,
    });
  },

  addMerchantCompany(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/by-company`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantMonitorFields(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resourceMerchantMonitorFields}`, {
      baseURL,
      headers,
      params,
    });
  },
  editMerchantApproved(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${supplierResource}/edit-request`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getTempMerchantByVisitors(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${tempMerchantResource}`, {
      baseURL,
      headers,
      params,
    });
  },
   
};
